import type {Vehicle} from "../types";

export const VEHICLE_SEARCH_MIN_LENGTH = 3;
export const VEHICLE_SEARCH_DEBOUNCE_MS = 650;

export function getVehicleComboboxLabel(vehicle: Vehicle): string {
  const plateParts = [vehicle.plate, vehicle.secondary_plate?.trim()].filter(Boolean);
  const parts = [...plateParts, vehicle.make, vehicle.model].filter(Boolean);
  return parts.length ? parts.join(" ") : String(vehicle.vehicle_id);
}
